import React from 'react';
import Stack from '@mui/material/Stack';
import {
  OrderStatsSortOption,
  OrderStatsQueryVariables,
  useOrderStatsLazyQuery,
  SortOrder,
} from 'src/graphql/report-service/generated/operations';
import { reportServiceClient } from 'src/utils/graph-clients';
import { IDatePeriod } from 'src/components/period-selector';
import OrderTable from './table';
import OrderStatsControls from './controls';

const Page = function () {
  const [period, setPeriod] = React.useState<undefined | IDatePeriod>(undefined);
  const [sortDirection, setSortDirection] = React.useState<SortOrder>(SortOrder.Ascending);
  const [sortBy, setSortBy] = React.useState<OrderStatsSortOption>(
    OrderStatsSortOption.OrderNumber,
  );
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(250);
  const [queryForOrders, { data, loading }] = useOrderStatsLazyQuery({
    client: reportServiceClient,
  });
  const variables: OrderStatsQueryVariables = {
    startDate: period?.dates?.start,
    endDate: period?.dates?.end,
    count: rowsPerPage,
    offset: page * rowsPerPage,
    sortBy,
    sortDirection,
  };

  const changePeriod = (newPeriod: IDatePeriod) => {
    if (newPeriod) {
      setPeriod(newPeriod);
      setPage(0);
    }
  };

  const changeSort = (id: OrderStatsSortOption) => {
    const isAsc = sortDirection === SortOrder.Ascending;
    // Only change sort direction if not changing the sortBy
    if (id === sortBy) {
      setSortDirection(isAsc ? SortOrder.Descending : SortOrder.Ascending);
    } else {
      setSortBy(id);
    }
    setPage(0);
  };

  React.useEffect(() => {
    if (period?.dates?.start && period?.dates?.end) {
      queryForOrders({ variables });
    }
  }, [period, sortDirection, sortBy, page, rowsPerPage]);

  return (
    <Stack direction="column" spacing={2}>
      <OrderStatsControls
        sortBy={sortBy}
        sortDirection={sortDirection}
        total={data?.orders.count}
        changePeriod={changePeriod}
        period={period}
        setPage={setPage}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
      <OrderTable
        sortBy={sortBy}
        sortDirection={sortDirection}
        changeSort={changeSort}
        loading={loading}
        orders={data?.orders?.data}
      />
    </Stack>
  );
};

export default Page;
